<template>
  <div class="vx-row">
    <div class="vx-col w-full md:w-3/4 lg:w-3/4 xl:w-3/4 mb-base">
      <vx-card :title="title">
        <!-- SLOT = ACTION -->
        <template slot="actions">
          <div class="flex items-center">
            <div class="vx-col w-full md:w-3/6 lg:w-3/6 xl:w-3/6 flex mr-5">
              <!-- <feather-icon :icon="'CalendarIcon'" :svgClasses="'stroke-current h-4 w-4 mb-1 mr-2'"></feather-icon> -->
              <vuejs-datepicker
                v-model="selected"
                format="yyyy/MM"
                minimum-view="month"
                input-class="input-class"
              ></vuejs-datepicker>
            </div>
          </div>
        </template>
        <div slot="no-body" class="p-6 pt-0 pb-0">
          <vs-row vs-type="flex" vs-justify="flex-end" class="mb-5">
            <customer-category
              @customerCategoryId="setCustomerCategoryId"
            ></customer-category>
            <sales-channel @salesChannelId="setSalesChannelId"></sales-channel>
            <sales
              @salesPersonalId="setSalesPersonalId"
              :territoryId="territoryId"
            ></sales>
            <territory
              @managerPersonalId="setManagerPersonalId"
              @territoryId="setTerritoryId"
              :territoryAreaId="territoryAreaId"
            ></territory>
            <sales-area
              @directorPersonalId="setDirectorPersonalId"
              @territoryAreaId="setTerritoryAreaId"
            ></sales-area>
          </vs-row>
          <div class="flex">
            <total-value-this
              :type="type"
              :year="year"
              :month="month"
              :label="'Month'"
              :salesChannelId="salesChannelId"
              :customerCategoryId="customerCategoryId"
              :territoryId="territoryId"
              :territoryAreaId="territoryAreaId"
              :salesPersonalId="salesPersonalId"
              :managerPersonalId="managerPersonalId"
              :directorPersonalId="directorPersonalId"
            ></total-value-this>
            <total-value-last
              :type="type"
              :year="year"
              :month="month"
              :label="'Month'"
              :salesChannelId="salesChannelId"
              :customerCategoryId="customerCategoryId"
              :territoryId="territoryId"
              :territoryAreaId="territoryAreaId"
              :salesPersonalId="salesPersonalId"
              :managerPersonalId="managerPersonalId"
              :directorPersonalId="directorPersonalId"
            ></total-value-last>
            <total-sales-order
              :type="type"
              :year="year"
              :month="month"
              :salesChannelId="salesChannelId"
              :customerCategoryId="customerCategoryId"
              :territoryId="territoryId"
              :territoryAreaId="territoryAreaId"
              :salesPersonalId="salesPersonalId"
              :managerPersonalId="managerPersonalId"
              :directorPersonalId="directorPersonalId"
            ></total-sales-order>
          </div>
          <grafik
            :type="type"
            :year="year"
            :month="month"
            :salesChannelId="salesChannelId"
            :customerCategoryId="customerCategoryId"
            :territoryId="territoryId"
            :territoryAreaId="territoryAreaId"
            :salesPersonalId="salesPersonalId"
            :managerPersonalId="managerPersonalId"
            :directorPersonalId="directorPersonalId"
          ></grafik>
        </div>
        <div class="flex text-center">
          <total-target :type="type" :year="year" :month="month"></total-target>
          <total-completion
            :type="type"
            :year="year"
            :month="month"
            :salesChannelId="salesChannelId"
            :customerCategoryId="customerCategoryId"
          ></total-completion>
          <total-target-ongoing
            :type="type"
            :year="year"
            :month="month"
            :salesChannelId="salesChannelId"
            :customerCategoryId="customerCategoryId"
          ></total-target-ongoing>
        </div>
        <div class="flex text-center">
          <total-target-special
            :type="type"
            :year="year"
            :month="month"
            :status="'special'"
          ></total-target-special>
          <total-completion-special
            :status="'special'"
            :type="type"
            :year="year"
            :month="month"
            :salesChannelId="salesChannelId"
            :customerCategoryId="customerCategoryId"
          ></total-completion-special>
          <total-target-ongoing-special
            :status="'special'"
            :type="type"
            :year="year"
            :month="month"
            :salesChannelId="salesChannelId"
            :customerCategoryId="customerCategoryId"
          ></total-target-ongoing-special>
        </div>
      </vx-card>
    </div>
    <div class="vx-col w-full md:w-1/4 lg:w-1/4 xl:w-1/4 mb-base">
      <goal-completion
        :type="type"
        :year="year"
        :month="month"
        :salesChannelId="salesChannelId"
        :customerCategoryId="customerCategoryId"
        :territoryId="territoryId"
        :territoryAreaId="territoryAreaId"
        :salesPersonalId="salesPersonalId"
        :managerPersonalId="managerPersonalId"
        :directorPersonalId="directorPersonalId"
      ></goal-completion>
    </div>
  </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import GoalCompletion from "./GoalCompletion";
import Grafik from "./dashboard-component/Grafik";
import TotalCompletion from "./dashboard-component/TotalCompletion";
import TotalTarget from "./dashboard-component/TotalTarget";
import TotalTargetOngoing from "./dashboard-component/TotalTargetOngoing";
import TotalSalesOrder from "./dashboard-component/TotalSalesOrder";
import TotalValueThis from "./dashboard-component/TotalValueThis";
import TotalValueLast from "./dashboard-component/TotalValueLast";
import SalesChannel from "./dashboard-component/SalesChannel";
import CustomerCategory from "./dashboard-component/CustomerCategory";

import TotalCompletionSpecial from "./dashboard-component/TotalCompletionSpecial";
import TotalTargetSpecial from "./dashboard-component/TotalTargetSpecial";
import TotalTargetOngoingSpecial from "./dashboard-component/TotalTargetOngoingSpecial";
import Sales from "./dashboard-component/Sales";
import Territory from "./dashboard-component/Territory";
import SalesArea from "./dashboard-component/SalesArea";
export default {
  components: {
    "vuejs-datepicker": Datepicker,
    GoalCompletion,
    Grafik,
    TotalCompletion,
    TotalTarget,
    TotalTargetOngoing,
    TotalSalesOrder,
    TotalValueThis,
    TotalValueLast,
    SalesChannel,
    CustomerCategory,
    TotalCompletionSpecial,
    TotalTargetSpecial,
    TotalTargetOngoingSpecial,
    Sales,
    Territory,
    SalesArea,
  },
  data() {
    return {
      title: "Monthly Order Report " + this.$userLogin.roles[0].DisplayName,
      type: "monthly",
      selected: Date.now(),
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      salesChannelId: null,
      customerCategoryId: null,
      salesPersonalId: null,
      managerPersonalId: null,
      directorPersonalId: null,
      territoryId: null,
      territoryAreaId: null,
    };
  },
  methods: {
    setSalesChannelId(val) {
      this.salesChannelId = val;
    },
    setCustomerCategoryId(val) {
      this.customerCategoryId = val;
    },
    setSalesPersonalId(val) {
      this.salesPersonalId = val;
    },
    setManagerPersonalId(val) {
      this.managerPersonalId = val;
    },
    setDirectorPersonalId(val) {
      this.directorPersonalId = val;
    },
    setTerritoryId(val) {
      this.territoryId = val;
    },
    setTerritoryAreaId(val) {
      this.territoryAreaId = val;
    },
  },
  mounted() {},
  watch: {
    selected: function (v) {
      var year = v.getFullYear();
      var month = v.getMonth() + 1;
      this.year = year;
      this.month = month;
    },
  },
};
</script>